export default __webpack_public_path__ + "static/media/p14.61a0ab86.jpg";